import FormControl from '@mui/material/FormControl'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormLabel from '@mui/material/FormLabel'
// import Slider from '@mui/material/Slider'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import Stack from '@mui/material/Stack'
import React from 'react'
import { URLSearchParamsInit } from 'react-router-dom'
import Tags, { SearchType, Tag } from '../../components/search/Tags'
import * as constants from '../../store/Constants'
import { Recipe } from "../../store/Recipe"
import { getAllOptions, getCurrentQuery, getOptions, updateQuery } from '../../utils/QueryHelpers'

interface AdvancedSearchInterface {
  index: Recipe[],
  filteredIndex: Recipe[],
  query: URLSearchParams,
  setQuery: (newParams: URLSearchParamsInit) => void
}

const AdvancedSearch = (props: AdvancedSearchInterface) => {

  // TODO: Also handle time and vegetarian.
  // Search through each column of the index and get all the possible options.
  const categoryTags = getOptions(constants.Category, props.index).map(option => { return { label: option } })
  const cuisineTags = getOptions(constants.Cuisine, props.index).map(option => { return { label: option } })
  const formTags = getOptions(constants.Form, props.index).map(option => { return { label: option } })
  const methodTags = getOptions(constants.Method, props.index).map(option => { return { label: option } })
  const ingredientTags = getOptions(constants.Ingredients, props.index).map(option => { return { label: option } })
  const keywordTags = getAllOptions({ index: props.filteredIndex }).map(option => { return { label: option } })
  const listsTags = getOptions(constants.Lists, props.index).map(option => { return { label: option } })

  // Parse the current query and return tags for each column separately.
  const categoryQuery = getCurrentQuery({ column: constants.Category, query: props.query })
  const cuisineQuery = getCurrentQuery({ column: constants.Cuisine, query: props.query })
  const formQuery = getCurrentQuery({ column: constants.Form, query: props.query })
  const methodQuery = getCurrentQuery({ column: constants.Method, query: props.query })
  const ingredientQuery = getCurrentQuery({ column: constants.Ingredients, query: props.query })
  const stringIngredientQuery = ingredientQuery.map(tag => tag.label) // Temp variables since bad type handling with getOptions I guess.
  const excludeIngredientQuery = getCurrentQuery({ column: constants.ExcludeIngredient, query: props.query })
  const keywordQuery = getCurrentQuery({ column: constants.Keyword, query: props.query })
  const stringKeywordQuery = keywordQuery.map(tag => tag.label) // Temp variables since bad type handling with getOptions I guess.
  const excludeKeywordQuery = getCurrentQuery({ column: constants.ExcludeKeyword, query: props.query })
  const listsQuery = getCurrentQuery({ column: constants.Lists, query: props.query })

  // Remove exclude keyword options if already used in keyword search.
  const excludeKeywordTags = keywordTags.filter(tag =>
    !stringKeywordQuery.includes(tag.label)
  )

  // Remove exclude keyword options if already used in keyword search.
  const excludeIngredientTags = ingredientTags.filter(tag =>
    !stringIngredientQuery.includes(tag.label)
  )

  // Handle current vetegarian query here.
  const vegetarianQuery = props.query.get(constants.Vegetarian)
  var vegetarianQueryState = "all"
  if (vegetarianQuery !== null) {
    vegetarianQueryState = vegetarianQuery
  }
  function setVegetarianQuery(event: React.ChangeEvent<HTMLInputElement>, value: string) {
    updateQuery({
      column: constants.Vegetarian,
      query: props.query,
      tags: [{ label: value }],
      setQuery: props.setQuery
    })
  }

  // Create a function for each column to update the specific query.
  function setCategoryQuery(tags: Tag[]) {
    updateQuery({
      column: constants.Category,
      query: props.query,
      tags: tags,
      setQuery: props.setQuery
    })
  }

  function setCuisineQuery(tags: Tag[]) {
    updateQuery({
      column: constants.Cuisine,
      query: props.query,
      tags: tags,
      setQuery: props.setQuery
    })
  }

  function setFormQuery(tags: Tag[]) {
    updateQuery({
      column: constants.Form,
      query: props.query,
      tags: tags,
      setQuery: props.setQuery
    })
  }

  function setMethodQuery(tags: Tag[]) {
    updateQuery({
      column: constants.Method,
      query: props.query,
      tags: tags,
      setQuery: props.setQuery
    })
  }

  function setIngredientQuery(tags: Tag[]) {
    updateQuery({
      column: constants.Ingredients,
      query: props.query,
      tags: tags,
      setQuery: props.setQuery
    })
  }

  function setExcludeIngredientQuery(tags: Tag[]) {
    updateQuery({
      column: constants.ExcludeIngredient,
      query: props.query,
      tags: tags,
      setQuery: props.setQuery
    })
  }

  function setExcludeKeywordQuery(tags: Tag[]) {
    updateQuery({
      column: constants.ExcludeKeyword,
      query: props.query,
      tags: tags,
      setQuery: props.setQuery
    })
  }

  function setListsQuery(tags: Tag[]) {
    updateQuery({
      column: constants.Lists,
      query: props.query,
      tags: tags,
      setQuery: props.setQuery
    })
  }

  // Handle current time query here.
  // TODO: I had issues with the slider updating the URL too fast.
  // const minTimeQuery = props.query.get(constants.MinTime)
  // const maxTimeQuery = props.query.get(constants.MaxTime)
  // var minTimeState = 0
  // var maxTimeState = 24
  // if (minTimeQuery !== null && maxTimeQuery !== null) {
  //   minTimeState = +minTimeQuery
  //   maxTimeState = +maxTimeQuery
  // }
  // var value = [minTimeState, maxTimeState]

  // const [value, setValue] = React.useState<number[]>([0, 24]);

  // const handleChange = (event: Event, newValue: number | number[]) => {
  //   setValue(newValue as number[]);
  // };

  // const handleChange = (event: Event | React.SyntheticEvent<Element, Event>, newValue: number | number[]) => {
  //   const totalNumber = (newValue as number[])
  //   value = totalNumber
  // };

  // const setTimeQuery = (event: Event | React.SyntheticEvent<Element, Event>, newValue: number | number[]) => {
  //   const totalNumber = (newValue as number[])
  //   const minTimeAsTag = {
  //     label: totalNumber[0].toString()
  //   } as Tag
  //   const maxTimeAsTag = {
  //     label: totalNumber[1].toString()
  //   } as Tag

  //   updateQuery({
  //     column: constants.MinTime,
  //     query: props.query,
  //     tags: [minTimeAsTag],
  //     setQuery: props.setQuery
  //   })

  //   updateQuery({
  //     column: constants.MaxTime,
  //     query: props.query,
  //     tags: [maxTimeAsTag],
  //     setQuery: props.setQuery
  //   })
  // }

  // function valuetext(value: number) {
  //   return `${value} Hr`;
  // }

  // const marks = [
  //   {
  //     value: 0,
  //     label: '0 Hr',
  //   },
  //   // {
  //   //   value: 1,
  //   //   label: '1 Hr',
  //   // },
  //   // {
  //   //   value: 2,
  //   //   label: '2 Hr',
  //   // },
  //   // {
  //   //   value: 3,
  //   //   label: '3 Hr',
  //   // },
  //   {
  //     value: 12,
  //     label: '12 Hr',
  //   },
  //   {
  //     value: 24,
  //     label: '24 Hr',
  //   },
  // ];

  return (
    <div>
      <Stack spacing={1.5}>
        <Tags
          label={'Exclude Keyword'}
          options={excludeKeywordTags}
          value={excludeKeywordQuery}
          setValue={setExcludeKeywordQuery}
          searchType={SearchType.AND}
        />
        <Tags
          label={"Lists"}
          options={listsTags}
          value={listsQuery}
          setValue={setListsQuery}
          searchType={SearchType.OR}
        />
        <Tags
          label={constants.Category}
          options={categoryTags}
          value={categoryQuery}
          setValue={setCategoryQuery}
          searchType={SearchType.OR}
        />
        <Tags
          label={constants.Cuisine}
          options={cuisineTags}
          value={cuisineQuery}
          setValue={setCuisineQuery}
          searchType={SearchType.OR}
        />
        <Tags
          label={constants.Form}
          options={formTags}
          value={formQuery}
          setValue={setFormQuery}
          searchType={SearchType.OR}
        />
        {/* <Slider
          getAriaLabel={() => 'Time range'}
          value={value}
          onChange={setTimeQuery}
          // onChangeCommitted={setTimeQuery}
          valueLabelDisplay="auto"
          getAriaValueText={valuetext}
          step={0.5}
          marks={marks}
          max={24}
          min={0}
        /> */}
        <Tags
          label={constants.Method}
          options={methodTags}
          value={methodQuery}
          setValue={setMethodQuery}
          searchType={SearchType.OR}
        />
        <FormControl>
          <FormLabel id="demo-row-radio-buttons-group-label">Vegetarian</FormLabel>
          <RadioGroup
            row
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"
            value={vegetarianQueryState}
            onChange={setVegetarianQuery}
          >
            <FormControlLabel value="all" control={<Radio />} label="All" />
            <FormControlLabel value="yes" control={<Radio />} label="Vegetarian" />
            <FormControlLabel value="no" control={<Radio />} label="Non-vegetarian" />
          </RadioGroup>
        </FormControl>
        <Tags
          label={constants.Ingredients}
          options={ingredientTags}
          value={ingredientQuery}
          setValue={setIngredientQuery}
          searchType={SearchType.OR}
        />
        <Tags
          label={'Exclude Ingredients'}
          options={excludeIngredientTags}
          value={excludeIngredientQuery}
          setValue={setExcludeIngredientQuery}
          searchType={SearchType.AND}
        />
      </Stack>
    </div>
  )
}

export default AdvancedSearch